import React from 'react'
import { PageHeader, PageTitle } from '../pageLayoutStyles'

export const HubCompanyMeetingRoomMyReservationsPage = (): JSX.Element => {
  return (
    <PageHeader>
      <PageTitle>Minhas reservas</PageTitle>
    </PageHeader>
  )
}
